
import { computed, defineComponent, PropType, Ref } from 'vue';
import HeroBanner from '@/shared/content/blocks/hero-banner/HeroBanner.vue';
import { HeroBannerTileModel, ImageFileModel } from '@/types/B2BcontentServerContract';
import pageStore from '@/shared/content/page.store';
import utils from '@/shared/utilities.service';
import Countdown from '@/shared/Countdown.vue';
import HeroBannerContent from '@/shared/content/blocks/hero-banner/HeroBannerContent.vue';
import constants from '@/shared/config/constants';

export default defineComponent({
    name: 'HeroBannerTile',
    components: { HeroBannerContent, Countdown, HeroBanner },
    props: {
        content: {
            type: Object as PropType<HeroBannerTileModel>,
            required: true,
        },
    },
    setup(props) {
        const isImageType = computed((): boolean => {
            return props.content?.media.type === constants.media.imageModel ?? false;
        });

        const isNativeVideo = computed(() => {
            return !!(props.content.media && props.content.media.type === constants.media.videoModel);
        });

        const image: Ref<ImageFileModel> = computed(() => {
            return isImageType.value && !isNativeVideo.value ? props.content.media.model : props.content.media.model.image;
        });

        const nativeVideo: Ref<ImageFileModel> = computed(() => {
            return isNativeVideo.value ? props.content.media.model : props.content.media.model.image;
        });

        const vimeoId = computed((): number | undefined => {
            return utils.ifMediaModelIsVideoReturnIdFromVimeoUrl(props.content.media);
        });

        const isActiveCampaign = computed((): boolean => {
            return props.content.campaign?.isCampaignActive ?? false;
        });

        const isCountdownEnabled = computed((): boolean => {
            return props.content.campaign?.countDownEnabled ?? false;
        });

        const isInCountdownMode = computed(() => {
            return isCountdownEnabled.value && !isActiveCampaign.value;
        });

        const bannerContent = computed(() => {
            return isActiveCampaign.value ? props.content.campaign : props.content;
        });

        const title = computed(() => {
            const altTitle = pageStore.altTitle;
            return altTitle ? utils.formatString(bannerContent.value.title, altTitle) : bannerContent.value.title;
        });

        return {
            bannerContent,
            image,
            nativeVideo,
            isActiveCampaign,
            isCountdownEnabled,
            isImageType,
            isInCountdownMode,
            vimeoId,
            title,
        };
    },
});
